// extracted by mini-css-extract-plugin
export var dropdownIcon = "_np-6";
export var imgContainer = "_np-3";
export var menuIcon = "_np-5";
export var pillWrapper = "_np-2";
export var pillsContainer = "_np-1";
export var subscriptionCard = "_np-0";
export var subscriptionLogo = "_np-4";